import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Form, Spin, Select, Input, Tabs, Space} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, SearchOutlined, RedoOutlined, PlusCircleOutlined, EditOutlined, DeleteOutlined, EyeOutlined, HomeOutlined } from '@ant-design/icons';
import PopupFrame from '../../component/popupFrame/popupFrame';//删除弹框
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import { ContextHandler } from '../../public/js/contextHandler';
import context from '../../public/js/context';
import trans from './translation';
import Message from '../../component/message/message';
import './messageTemplate.css';
import SelectUserModel from './selectUserModel';
import SelectUserModelBcc from './selectUserModelBcc';
const { TabPane } = Tabs;
const { Option } = Select;
const { TextArea } = Input;
const ClassicEditor = window.ClassicEditor;

const MessageTemplate = (props) => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isAudit, setIsAudit] = useState(false);
    const [auditModel, setAuditModel] = useState({});
    const [tabIndex, setTabIndex] = useState("1");
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [flag, setFlag] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [messageTemplateModel, setMessageTemplateModel] = useState({});
    const [ckeditor, setCkeditor] = useState(null);
    const [linkValidity, setLinkValidity] = useState([]);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [deleteTipText, setDeleteTipText] = useState("");
    const [isSelectUserModal, setIsSelectUserModal] = useState(false);
    const [userIdList,setUserIdList] =  useState([]);

    const [selectedStudentList,setSelectedStudentList]=  useState([]);
    const [selectedAcademicList,setSelectedAcademicList]=  useState([]);
    const [selectedIpList,setSelectedIPList]=  useState([]);

    const [selectedStudentBccList,setSelectedStudentBccList]=  useState([]);
    const [selectedAcademicBccList,setSelectedAcademicBccList]=  useState([]);
    const [selectedIpBccList,setSelectedIPBccList]=  useState([]);
    const [isSelectUserModalBcc, setIsSelectUserModalBcc] = useState(false);

    const tableColumns = {
        templateCode: "template_code",
        templateName: "template_name",
        seq: "disp_seq",
        recipient: 'recipient',
        status: 'status'
    }

    useEffect(() => {
        search(pageSize, 1, "N");
        searchLinkValidityTime();
        ClassicEditor.create(document.querySelector('#editor'), Config.ckEditorConfig)
            .then(editor => {
                setCkeditor(editor);
            }).catch(error => { console.log(error) });
    }, []);


    const searchLinkValidityTime = () => {
        Base.callBackApi("commonDropDown/searchSysParam", { segment: "TEMPLATE_TYPE" }).then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object;
                list.sort((a, b) => a.dispSeq - b.dispSeq);
                setLinkValidity(list);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const deleteOne = (model, e, type) => {
        e.stopPropagation();
        setMessageTemplateModel(model)
        setIsDeleteFrame(true);
        if (type == "templateCode") {
            setDeleteTipText("Email Template Code" + ":" + model.templateCode)
        }
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else if ("reset" === flag) {
            model = {}
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("messageTemplate/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    /**用戶信息 查詢change方法 */
    const searchChange = (k, e) => {
        messageShowHandler();
        setSearchModel(newModel => {
            return { ...newModel, ...{ [k]: e } };
        });
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
        search(pageSize, current, "reset");
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({ status: "Y", recipient: 'GENERAL' });
        setSelectedStudentList([])
        setSelectedAcademicList([])
        setSelectedIPList([])
        setSelectedStudentBccList([])
        setSelectedAcademicBccList([])
        setSelectedIPBccList([])
        ckeditor.setData('');
        setFlag("add");
        setTabIndex("2");
    }

    const update = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        messageShowHandler();
        setSelectedStudentList([])
        setSelectedAcademicList([])
        setSelectedIPList([])
        setSelectedStudentBccList([])
        setSelectedAcademicBccList([])
        setSelectedIPBccList([])
        ckeditor.setData(model.content ?? '');
        searchById(model.emailTemplateId);
        setTabIndex("2");
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = messageTemplateModel;
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("messageTemplate/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchById = (emailTemplateId) => {
        Base.callBackApi("messageTemplate/searchById", emailTemplateId).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {};
                setFlag("edit");
                initForm(model)
                if(model.userModelCcList){
                    const groupByUserType = model.userModelCcList.reduce((acc, user) => {
                        if (!acc[user.userType]) {
                            acc[user.userType] = [];
                        }
                        acc[user.userType].push(user);
                        return acc;
                    }, {});
                    groupByUserType['ACADEMIC'] && setSelectedAcademicList(groupByUserType['ACADEMIC'])
                    groupByUserType['STUDENT'] && setSelectedStudentList(groupByUserType['STUDENT'])
                    groupByUserType['PARTNER'] && setSelectedIPList(groupByUserType['PARTNER'])
                }
                if(model.userModelBccList){
                    const groupByUserType = model.userModelBccList.reduce((acc, user) => {
                        if (!acc[user.userType]) {
                            acc[user.userType] = [];
                        }
                        acc[user.userType].push(user);
                        return acc;
                    }, {});
                    groupByUserType['ACADEMIC'] && setSelectedAcademicBccList(groupByUserType['ACADEMIC'])
                    groupByUserType['STUDENT'] && setSelectedStudentBccList(groupByUserType['STUDENT'])
                    groupByUserType['PARTNER'] && setSelectedIPBccList(groupByUserType['PARTNER'])
                }
               
                setMessageTemplateModel(model)
                // 处理图片
                let content;
                if(model.content) {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = model.content;
                    var images = tempDiv.getElementsByTagName('img');
                    for (var i = 0; i < images.length; i++) {
                        var img = images[i];
                        var src = img.getAttribute('src');
                        var index = src.indexOf(Config.imgServer);
                        if (index !== -1) {
                            var newSrc = src + '?' + Config.sasToken;
                            img.setAttribute('src', newSrc);
                        }
                    }
                    content = tempDiv.innerHTML;
                }
                ckeditor.setData(content);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            emailTemplateId: model.emailTemplateId ?? '',
            templateCode: model.templateCode ?? '',
            templateName: model.templateName ?? '',
            recipient: model.recipient ?? '',
            cc: model.cc ?? '',
            bcc: model.bcc ?? '',
            designatedCc: model.designatedCc ?? '',
            designatedBcc: model.designatedBcc ?? '',
            templateDescription: model.templateDescription ?? '',
            status: model.status ?? '',
            content: model.content ?? '',
            seq: model.seq ?? '',
        });

    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        setSpinInfo(trans.dataBeSaving[Config.backLang])
        let url = "";
        if (flag === "add") {
            url = "messageTemplate/insert";
        } else {
            url = "messageTemplate/update"
            values.emailTemplateId = messageTemplateModel.emailTemplateId;
            values.lastUpdatedDate = messageTemplateModel.lastUpdatedDate;
        }
        let content = ckeditor.getData();
        if(content) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            var images = tempDiv.getElementsByTagName('img');
            for (var i = 0; i < images.length; i++) {
                var img = images[i];
                var src = img.getAttribute('src');
                var index = src.indexOf('?sv=');
                if (index !== -1) {
                    var newSrc = src.substring(0, index);
                    img.setAttribute('src', newSrc);
                }
            }
            values.content = tempDiv.innerHTML;
        }
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                searchById(data.object)
                errFrameShow("success", trans.saveSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const cancel = () => {
        messageShowHandler();
        setTabIndex("1");
        ckeditor.setData('');
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!searchModel.orderBy) {
            if (orderBy !== searchModel.orderBy) {
                searchModel.orderBy = orderBy;
                search(pageSize, 1, "N", true);
            }
        }
    }

    const columns = [
        {
            title: trans.templateCode[Config.backLang],
            dataIndex: 'templateCode',
            className: 'tableWidth25',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'templateCode') },
        },
        {
            title: trans.templateName[Config.backLang],
            dataIndex: 'templateName',
            className: 'tableWidth40',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'templateName') },
        },
        
        {
            title: 'Recipient',
            dataIndex: 'recipient',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'recipient') },
            render: (text) => ContextHandler.getMapValue('recipientMap', text)
        },
        {
            title: trans.activeInd[Config.backLang],
            dataIndex: 'status',
            className: 'tableWidth9',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'status') },
            render: (text) => ContextHandler.getMapValueTransalation('emailActiveTransalation', text)
        },
        {
            title: trans.controls[Config.backLang],
            dataIndex: '',
            fixed: 'right',
            width: 206,
            className: 'sysControls',
            render: (text, record) => <div className='operation'>
                <div className='sysUpdate' onClick={(e) => update(record, e)} hidden={Config.funcInfo.canUpdate === "N"}><EditOutlined /> {trans.update[Config.backLang]}</div>
                <div className='sysDelete' onClick={(e) => deleteOne(record, e, "templateCode")} hidden={Config.funcInfo.canDelete === "N"}><DeleteOutlined /> {trans.delete[Config.backLang]}</div>
                <div className='sysLogs' onClick={(e) => audit(record, e)}><EyeOutlined /> {trans.audit[Config.backLang]}</div>
            </div>
        },
    ];

    const closeSelectUserModal = (flag, selectedStudent,selectedAcademic,selectedIP) => {
        if(flag) {
            var userIdString ="";
            if(selectedStudent.length>0){
                const studentsUserId = selectedStudent.map(item => `${item.userId}`).join(',');
                userIdString+= studentsUserId+","
            }
            if(selectedAcademic.length>0){
                const academicUserId = selectedAcademic.map(item => `${item.userId}`).join(',');
                userIdString+= academicUserId+","
            }
            if(selectedIP.length>0){
                const ipUserId = selectedIP.map(item => `${item.userId}`).join(',');
                userIdString+= ipUserId+","
            }
            setSelectedStudentList(selectedStudent)
            setSelectedAcademicList(selectedAcademic)
            setSelectedIPList(selectedIP)
            userIdString = userIdString.slice(0, -1);
            form.setFieldsValue({ designatedCc: userIdString });
        }
        setIsSelectUserModal(false);
    }

    const deleteDesignatedCc = (type, index) => {
        var userIdString ="";
        if(selectedStudentList.length > 0) {
            let list = selectedStudentList;
            if(type === "student") {
                list.splice(index, 1);
                setSelectedStudentList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        if(selectedAcademicList.length > 0) {
            let list = selectedAcademicList;
            if(type === "academic") {
                list.splice(index, 1);
                setSelectedAcademicList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        if(selectedIpList.length > 0) {
            let list = selectedIpList;
            if(type === "ip") {
                list.splice(index, 1);
                setSelectedIPList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        userIdString = userIdString.slice(0, -1);
        form.setFieldsValue({ designatedCc: userIdString });
    }

    const closeSelectUserModalBcc = (flag, selectedStudent,selectedAcademic,selectedIP) => {
        if(flag) {
            var userIdString ="";
            if(selectedStudent.length>0){
                const studentsUserId = selectedStudent.map(item => `${item.userId}`).join(',');
                userIdString+= studentsUserId+","
            }
            if(selectedAcademic.length>0){
                const academicUserId = selectedAcademic.map(item => `${item.userId}`).join(',');
                userIdString+= academicUserId+","
            }
            if(selectedIP.length>0){
                const ipUserId = selectedIP.map(item => `${item.userId}`).join(',');
                userIdString+= ipUserId+","
            }
            setSelectedStudentBccList(selectedStudent)
            setSelectedAcademicBccList(selectedAcademic)
            setSelectedIPBccList(selectedIP)
            userIdString = userIdString.slice(0, -1);
            form.setFieldsValue({ designatedBcc: userIdString });
        }
        setIsSelectUserModalBcc(false);
    }

    const deleteDesignatedBcc = (type, index) => {
        var userIdString ="";
        if(selectedStudentBccList.length > 0) {
            let list = selectedStudentBccList;
            if(type === "student") {
                list.splice(index, 1);
                setSelectedStudentBccList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        if(selectedAcademicBccList.length > 0) {
            let list = selectedAcademicBccList;
            if(type === "academic") {
                list.splice(index, 1);
                setSelectedAcademicBccList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        if(selectedIpBccList.length > 0) {
            let list = selectedIpBccList;
            if(type === "ip") {
                list.splice(index, 1);
                setSelectedIPBccList([...list]);
            }
            let ids = list.map(item => `${item.userId}`).join(',');
            userIdString += ids + ",";
        }
        userIdString = userIdString.slice(0, -1);
        form.setFieldsValue({ designatedBcc: userIdString });
    }

    return (
        <div id="container" className="template messageTemplate">
            <div className='breadcrumb'>

                <HomeOutlined /> / {trans.sysManagement[Config.backLang]} / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : (Config.backLang === 'EN' ? 'En' : ''))]}</span>
            </div>
            <Message ref={messageRef} />
            <div className='templateMain'>
                {/* <div className="sysModelTitle">{trans.mailNotifications[Config.backLang]}</div> */}
                <Spin spinning={isLoad} size="large" tip={spinInfo}>
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <Tabs activeKey={tabIndex} onChange={(e) => handleSelect(e)}>
                        <TabPane tab={trans.list[Config.backLang]} key="1">
                            <div className='sysSearchRows'>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysTitle messageTemplateTitle">{trans.templateCode[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder={trans.templateCode[Config.backLang]} value={searchModel.templateCode}
                                                onChange={(e) => searchChange('templateCode', e.target.value)}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle messageTemplateTitle">{trans.templateName[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Input type="text" placeholder={trans.templateName[Config.backLang]} value={searchModel.templateName}
                                                onChange={(e) => searchChange('templateName', e.target.value)}
                                                onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null} />
                                        </div>
                                    </div>
                                
                                    <div className='sysCol'>
                                        <div className="sysTitle messageTemplateTitle">Recipient</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" value={searchModel.recipient} placeholder='Recipient' onChange={(e) => searchChange('recipient', e)}>
                                                <Option value='' ></Option>
                                                {context.recipientMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysTitle messageTemplateTitle">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysSerchInput">
                                            <Select className="sysSelect" value={searchModel.status} placeholder='Status' onChange={(e) => searchChange('status', e)}>
                                                <Option value='' ></Option>
                                                {context.emailActiveTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                            </Select>
                                        </div>
                                    </div>
                                    <div className='sysSearchButton'>
                                        <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                                        <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                                    </div>
                                </div>
                            </div>
                            <div className="sysLineEight"></div>
                            <Space size={[5, 5]} wrap className="sysButtonRelative">
                                <Button className="sysBtn btnBlue" type="primary" onClick={add} hidden={Config.funcInfo.canInsert === "N"} icon={<PlusCircleOutlined />}>{trans.add[Config.backLang]}</Button>
                            </Space>
                            <div className="sysTable" id="tableOne">
                                <Table
                                    rowKey="emailTemplateId"
                                    scroll={{ x: 1350 }}
                                    columns={columns} //列名
                                    dataSource={tables} //数据
                                    pagination={{  //分页
                                        showSizeChanger: true,                          //是否显示可以设置几条一页的选项
                                        onChange: onChange,                        //上页下页或者跳页方法
                                        onShowSizeChange: onShowSizeChange,        //每页显示多少条数据方法
                                        total: tablesCount,             //总共多少条数据
                                        current: current,                //当前页
                                        pageSize: pageSize,              //每页显示多少条数据
                                        defaultCurrent: 1,                               //默认当前页为1
                                        size: "small"
                                    }}
                                    onChange={handleTableChange}
                                />
                            </div>
                        </TabPane>
                        <TabPane tab={trans.mailNotifications[Config.backLang]} key="2" forceRender={true}>
                            <Form form={form} onFinish={onFinish}>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill ">{trans.templateCode[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="templateCode"
                                                rules={[
                                                    { required: true, message: trans.templateCodeNoIsNull[Config.backLang] },
                                                ]}
                                                getValueFromEvent={(e) => Base.codeChange(e, 50)}
                                            >
                                                <Input type="text" placeholder={trans.templateCode[Config.backLang]} maxLength={50} disabled={flag == 'edit'} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.templateName[Config.backLang]}</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="templateName"
                                                rules={[
                                                    { required: true, message: trans.templateNameNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Input type="text" placeholder={trans.templateName[Config.backLang]} maxLength={150} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.templateType[Config.backLang]}</div>
                                        <div className="sysInputMax">
                                            <Form.Item
                                                name="templateDescription"
                                            >
                                                <Input type="text" placeholder={trans.templateType[Config.backLang]} maxLength={500} />
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">Recipient</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="recipient"
                                                rules={[
                                                    { required: true, message: 'Recipient is required.' },
                                                ]}
                                            >
                                                <Select className="sysSelect" 
                                                >
                                                    {context.recipientMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                    <div className='sysCol'>
                                        <div className="sysParam mustFill">{trans.activeInd[Config.backLang]}</div>
                                        <div className="sysInput">
                                            <Form.Item
                                                name="status"
                                                rules={[
                                                    { required: true, message: trans.activeIndNoIsNull[Config.backLang] },
                                                ]}
                                            >
                                                <Select className="sysSelect" 
                                                >
                                                    {context.emailActiveTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">CC</div>
                                        <div className="sysInput" >
                                            <Form.Item
                                                name="cc"
                                            >

                                                <Select className="sysSelect"
                                                >
                                                    {context.recipientAdminMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                     
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => { setIsSelectUserModal(true) }}>Select Designated CC</Button>
                                        </div>
                                        <div className="sysInputMax">
                                            <div className='messageTemplateTagRow'>
                                                {selectedStudentList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.firstName? `${item.firstName} ${item.lastName}(${item.email})` :`${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedCc("student", index)}/>
                                                </div>)}
                                                {selectedAcademicList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.firstName? `${item.firstName + ' ' + item.lastName}(${item.email})`: `${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedCc("academic", index)}/>
                                                </div>)}
                                                {selectedIpList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.contactName? `${item.contactName}(${item.contactEmail})`: `${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedCc("ip", index)}/>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow' hidden>
                                    <div className='sysCol'>
                                        <div className="sysParam"></div>
                                        <div className="sysInputMax"  >
                                            <Form.Item
                                                name="designatedCc"
                                            >
                                                <TextArea style={{ width: '80%' }} type="text"  disabled />
                                                
                                            </Form.Item>
                                        </div>
                                        
                                    </div>
                                </div>

                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">BCC</div>
                                        <div className="sysInput" >
                                            <Form.Item
                                                name="bcc"
                                            >

                                                <Select className="sysSelect"
                                                >
                                                    {context.recipientAdminMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                                </Select>
                                     
                                            </Form.Item>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">
                                            <Button type="primary" className='sysBtn btnBlue' onClick={() => { setIsSelectUserModalBcc(true) }}>Select Designated BCC</Button>
                                        </div>
                                        <div className="sysInputMax">
                                            <div className='messageTemplateTagRow'>
                                                {selectedStudentBccList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.firstName? `${item.firstName} ${item.lastName}(${item.email})` :`${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedBcc("student", index)}/>
                                                </div>)}
                                                {selectedAcademicBccList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.firstName? `${item.firstName + ' ' + item.lastName}(${item.email})`: `${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedBcc("academic", index)}/>
                                                </div>)}
                                                {selectedIpBccList.map((item, index) => <div className='messageTemplateTag' key={index}>
                                                    <div>{item.contactName? `${item.contactName}(${item.contactEmail})`: `${item.userName}(${item.email})`}</div>
                                                    <CloseCircleOutlined className='messageTemplateTagImg' onClick={() => deleteDesignatedBcc("ip", index)}/>
                                                </div>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='sysRow' hidden>
                                    <div className='sysCol'>
                                        <div className="sysParam"></div>
                                        <div className="sysInputMax"  >
                                            <Form.Item
                                                name="designatedBcc"
                                            >
                                                <TextArea style={{ width: '80%' }} type="text"  disabled />
                                                
                                            </Form.Item>
                                        </div>
                                        
                                    </div>
                                </div>
                                
                                <div className='sysRow'>
                                    <div className='sysCol'>
                                        <div className="sysParam">{trans.content[Config.backLang]}</div>
                                        <div className="sysInputs editor">
                                            <div id="editor" className="editor"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sysSaveButton">
                                    <Button className="sysBtn btnBlue" type="primary" disabled={isLoad} htmlType="submit" icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>
                                    <Button className="sysBtn" onClick={cancel} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                                </div>
                            </Form>
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
            {isSelectUserModal && <SelectUserModel onClose={closeSelectUserModal} selectedStudentList={selectedStudentList} selectedAcademicList={selectedAcademicList} selectedIpList={selectedIpList}/> }
            {isSelectUserModalBcc && <SelectUserModelBcc onClose={closeSelectUserModalBcc} selectedStudentList={selectedStudentBccList} selectedAcademicList={selectedAcademicBccList} selectedIpList={selectedIpBccList}/> }
        </div>
    )
}

export default MessageTemplate;